export class NotConnectedError extends Error {
    constructor(...params: any) {
        super(...params);
        if (params[0] && typeof params[0] === 'string') {
            // eslint-disable-next-line prefer-destructuring
            this.message = params[0];
        }
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotConnectedError);
        }

        this.name = 'NotConnectedError';
    }

    static fromResponseCodeZero() {
        return new NotConnectedError(`The api can not be called as there is no connection`);
    }
}